import React, { useState } from 'react'
import {
    Button,
    Input,
    Label,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
} from 'reactstrap'
import Price from '../../../../components/Payment/Price/Price'
import Icon from '../../../../components/Icons/Icon'
import EditIcon from '../../../../assets/img/icons/EDIT ICON.svg'

import './CartItem.css'

const CartItem = ({
    id,
    name,
    meterage,
    discount,
    price,
    imageUrl,
    onRemove,
    onEdited,
}) => {
    const [isEditing, setIsEditing] = useState(false)
    const [currentMeterage, setCurrentMeterage] = useState(meterage)

    const onEditing = () => {
        if (isEditing) onEdited(id, currentMeterage)
        setIsEditing(!isEditing)

        const input = document.getElementById('meterage' + id)
        if (input) input.focus()
    }

    const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false)
    const toggle = () => setIsDeleteModalVisible(!isDeleteModalVisible)

    return (
        <div className="cart-item">
            <div className="cart-item__name-wrapper">
                <h4 className="cart-item__name">{name}</h4>
                <img className="cart-item__img" src={imageUrl} />
            </div>
            <div className="cart-item__actions align-self-end">
                <Button onClick={onEditing}>
                    {isEditing ? (
                        'ذخیره'
                    ) : (
                        <>
                            <Icon size="sm" src={EditIcon} />
                            ویرایش
                        </>
                    )}
                </Button>
                <Button className="remove-btn" onClick={toggle}>
                    حذف
                </Button>
            </div>
            <div className="cart-item__price-wrapper mr-auto d-flex flex-column">
                <div className="d-flex justify-content-end align-items-center mb-auto">
                    <p>پارچه مورد نیاز</p>
                    <Input
                        value={currentMeterage}
                        disabled={!isEditing}
                        type="number"
                        id={'meterage' + id}
                        className="cart-item__meterage-input"
                        onChange={(e) => setCurrentMeterage(e.target.value)}
                    />
                    <span>متر</span>
                </div>

                <div className="d-flex justify-content-end align-items-baseline">
                    <Label>تخفیف</Label>
                    <Price price={discount} discounted />
                </div>
                <div className="d-flex justify-content-end align-items-baseline">
                    <Label>قیمت براساس متراژ</Label>
                    <Price
                        price={price * (currentMeterage ?? 1)}
                        size="md"
                        color="secondary"
                    />
                </div>
            </div>

            <Modal
                isOpen={isDeleteModalVisible}
                toggle={toggle}
                className="cart-item__delete-modal"
            >
                <ModalHeader>حذف از سبد خرید</ModalHeader>
                <ModalBody>آیا اطمینان دارید؟</ModalBody>
                <ModalFooter>
                    <Button
                        color="danger"
                        onClick={() => {
                            toggle()
                            onRemove(id)
                        }}
                    >
                        بلی، حذف کن
                    </Button>
                    <Button color="secondary" onClick={toggle}>
                        خیر
                    </Button>
                </ModalFooter>
            </Modal>
        </div>
    )
}

export default CartItem
